import { render, staticRenderFns } from "./navIcon.vue?vue&type=template&id=5a399149"
import script from "./navIcon.vue?vue&type=script&lang=js"
export * from "./navIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports